import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Optional, Inject, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import * as i2 from '@angular/common/http';
import { HttpHeaders, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { config as config$1, API_CONFIG, ApiModule } from '@ff/api';
import * as i1 from '@ff/user';
import { UserModule } from '@ff/user';
import { BehaviorSubject } from 'rxjs';

const config = {
    host: config$1.host,
    username: 'email',
    endpoints: {
        login: '/auth/login',
        logout: '/auth/logout'
    }
};

const AUTH_CONFIG = new InjectionToken('auth.config');

// @dynamic
class AuthService {
    constructor(_apiConfig, _config, _userService, _httpClient) {
        this._apiConfig = _apiConfig;
        this._config = _config;
        this._userService = _userService;
        this._httpClient = _httpClient;
        this._config = Object.assign(config, this._config);
        this._apiConfig = Object.assign(config$1, this._apiConfig);
        this._isLoggedIn = new BehaviorSubject(false);
        // Subscribe to user object
        this._userService.getUser().subscribe((user) => {
            this._isLoggedIn.next(user != null);
        });
    }
    /**
     * Return observable
     */
    isLoggedIn() {
        return this._isLoggedIn;
    }
    /**
     * Attempt to login user then fetch user from remote server
     * Returns a Promise<any>
     * @param data
     */
    login(data) {
        const url = this._config.host + this._config.endpoints.login;
        return this._httpClient.post(url, data.value)
            .toPromise()
            .then(response => (response.data))
            .then(response => {
            if (response.token) {
                localStorage.setItem('_token', response.token);
            }
            return this._userService.fetch();
        });
    }
    /**
     * Attempt to logout user
     * Returns a Promise<any>
     */
    logout() {
        const url = this._config.host + this._config.endpoints.logout;
        this._userService.getUser().next(null);
        return this._httpClient.get(url)
            .toPromise()
            .then(() => {
            localStorage.removeItem('_token');
        });
    }
}
AuthService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: AuthService, deps: [{ token: API_CONFIG, optional: true }, { token: AUTH_CONFIG, optional: true }, { token: i1.UserService }, { token: i2.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
AuthService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: AuthService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: AuthService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_CONFIG]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [AUTH_CONFIG]
                }] }, { type: i1.UserService }, { type: i2.HttpClient }]; } });

class BearerInjection {
    intercept(req, next) {
        const token = localStorage.getItem('_token');
        let headers = new HttpHeaders();
        if (req.headers) {
            headers = req.headers;
        }
        if (token) {
            headers = headers
                .set('Accept', `application/json`)
                .set('Authorization', `Bearer ${token}`);
        }
        const duplicate = req.clone({ headers: headers });
        return next.handle(duplicate);
    }
}
BearerInjection.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: BearerInjection, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BearerInjection.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: BearerInjection });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: BearerInjection, decorators: [{
            type: Injectable
        }] });

class AuthModule {
}
AuthModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: AuthModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AuthModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: AuthModule, imports: [CommonModule,
        ReactiveFormsModule,
        HttpClientModule,
        RouterModule,
        ApiModule,
        UserModule] });
AuthModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: AuthModule, providers: [
        AuthService,
        {
            provide: HTTP_INTERCEPTORS, useClass: BearerInjection, multi: true
        },
    ], imports: [[
            CommonModule,
            ReactiveFormsModule,
            HttpClientModule,
            RouterModule,
            ApiModule,
            UserModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.0", ngImport: i0, type: AuthModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        HttpClientModule,
                        RouterModule,
                        ApiModule,
                        UserModule
                    ],
                    providers: [
                        AuthService,
                        {
                            provide: HTTP_INTERCEPTORS, useClass: BearerInjection, multi: true
                        },
                    ],
                    exports: []
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AUTH_CONFIG, AuthModule, AuthService, BearerInjection };
